const host = () => document.getElementById('toast');

export function toast(message, { type = 'info', duration = 2500 } = {}) {
  const h = host();
  if (!h) return;
  const el = document.createElement('div');
  el.className = 'toast-msg ' + type;
  el.textContent = message;
  h.appendChild(el);
  requestAnimationFrame(() => el.classList.add('show'));
  setTimeout(() => {
    el.classList.remove('show');
    setTimeout(() => el.remove(), 220);
  }, duration);
}
